import { render, staticRenderFns } from "./LoadingPermission.vue?vue&type=template&id=3e4e7351&scoped=true&"
import script from "./LoadingPermission.vue?vue&type=script&lang=js&"
export * from "./LoadingPermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4e7351",
  null
  
)

export default component.exports